import { Outlet } from "react-router-dom";

import { useUser } from "@components/user-context";
import { TopNav, TopNavItem } from "@components/v2/top-nav";

export const AttributionLayout = () => {
  const { user } = useUser();

  return (
    <>
      <div
        className="pt-5 px-6 flex items-center justify-between overflow-hidden"
        style={{
          background:
            "linear-gradient(180deg, var(--v2-bg-secondary, #F9FAFF) 83.66%, var(--v2-highlight-information-hover, #CDD3FF) 183.87%)",
        }}
      >
        <TopNav title="Attribution">
          <TopNavItem to="sales">Sales</TopNavItem>
          {user.featureFlags.productAnalytics && (
            <TopNavItem to="product-analytics">Products</TopNavItem>
          )}
          <TopNavItem to="orders">Orders</TopNavItem>
          <TopNavItem to="creative-analytics">Creatives</TopNavItem>
        </TopNav>
      </div>
      <Outlet />
    </>
  );
};
